import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { generatePath } from 'react-router';
import { useDefaultErrorHandler } from '~/components/Error/Error.hooks';
import { HttpError } from '~/components/Error/HttpError';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export interface Zone {
  zoneId: number;
  snapshot: {
    citizenNftLevel: number;
    citizenNftCount: number;
    levelUpPassCount: number;
  };
  participationCriteria: {
    asset: {
      assetType: string;
      amount: number;
    };
    levelUpPassCount: number;
  };
}

export interface ZoneRequestParams {
  landId: number;
  zoneId: number;
}

export type VaultVerifyError = HttpError<{
  responseData: {
    sellerInfoUri?: string;
  };
}>;

export const zoneUrl = '/api/citizen/v1/lands/:landId/zones/:zoneId';
export const requestZone = async (params: ZoneRequestParams) => {
  const { data } = await axios.get<Zone>(generatePath(zoneUrl, params));
  return data;
};

export const useZone = (
  params: ZoneRequestParams,
  options?: UseDosiminQueryOptions<Zone, VaultVerifyError>
) => {
  const handleDefaultError = useDefaultErrorHandler();
  return useQuery<Zone, VaultVerifyError>({
    queryKey: ['land', params.landId, 'zone', params.zoneId],
    queryFn: () => requestZone(params),
    initialData: (): Zone => ({
      zoneId: params.zoneId ?? 1,
      snapshot: {
        citizenNftLevel: 0,
        citizenNftCount: 0,
        levelUpPassCount: 0,
      },
      participationCriteria: {
        asset: {
          assetType: 'DON',
          amount: 0,
        },
        levelUpPassCount: 0,
      },
    }),
    onError: handleDefaultError,
    staleTime: 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
};
